/// <reference path="../../node_modules/devextreme/dist/ts/dx.all.d.ts" />

/// <reference path="../commons/constants.ts"/>

namespace Seac.DxComponents {
	class DxComponentsUtils {
		/** Metodo placeholder che permette la personalizzazione degli export in XLSX delle griglie */
		public customizeExcelCell(options: { gridCell?: DevExpress.excelExporter.ExcelDataGridCell, excelCell?: any }): any { }

		/**
		* Metodo utilizzato per la selezione di un elemento di una griglia contenuta all'interno di una DropDownBox DevExtreme
		* @param component è l'istanza della DropDownBox
		* @param selectedItems sono gli elementi selezionati (normalemente uno)
		*/
		public selectGridItem(component: DevExpress.ui.dxDropDownBox, selectedItems: any): void {
			let keys = selectedItems.selectedRowKeys;
			component.option(Seac.Commons.Constants.DevExpress.dxValue, keys);
			component.close();
		}

		/**
		* Metodo utilizzato per la selezione di elementi multipli di una lista contenuta all'interno di una DropDownBox DevExtreme,
		* a differenza del metodo precedente non chiude le DropDownBox al termine
		* @param component è l'istanza della DropDownBox
		* @param selectedItems sono gli elementi selezionati
		*/
		public selectMultipleGridItems(component: DevExpress.ui.dxDropDownBox, selectedItems: any): void {
			component.option(Seac.Commons.Constants.DevExpress.dxValue, selectedItems.selectedRowKeys);
		}

		/**
		* Metodo utilizzato per la selezione di un elemento di una lista contenuta all'interno di una DropDownBox DevExtreme
		* @param event Evento (purtroppo è <any>, perché DevExtreme non ha messo a disposizione il tipo)
		* @param dropDownBoxId ID della DropDownBox
		*/
		public selectListItem_InDropDownBox(event: any, dropDownBoxId: string): void {
			const dropDownBoxInstance: DevExpress.ui.dxDropDownBox = $(`#${dropDownBoxId}`).dxDropDownBox(Seac.Commons.Constants.DevExpress.dxInstance);
			// Ricavo il nome della proprietà impostata come valueExpr.
			const key: string = dropDownBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValueExpr);
			if (event?.addedItems.length) {
				dropDownBoxInstance.option(Seac.Commons.Constants.DevExpress.dxValue, event.addedItems[0][key]);
			}else {
				dropDownBoxInstance.reset();
			}
			dropDownBoxInstance.close();
		}

		/**
		* Metodo utilizzato per la selezione di elementi multipli di una lista contenuta all'interno di una DropDownBox DevExtreme
		* @param event Evento DxDropDownBoxValueChangeEvent
		* @param embeddedGridId Id della griglia che si trova all'interno della DropDownBox
		*/
		public embeddedDropDownBoxGrid_valueChange(event: Seac.Commons.DxEvents.DxDropDownBoxValueChangeEvent, embeddedGridId: string): void {
			const dataGrid: JQuery = $(`#${embeddedGridId}`);

			if (dataGrid.length) {
				const dataGridInstance: DevExpress.ui.dxDataGrid = dataGrid.dxDataGrid(Seac.Commons.Constants.DevExpress.dxInstance);
				dataGridInstance.selectRows(event.value, false);
			}
		}

		/**
		* Funzione richiamata dalle DropDownBox della pagina che visualizzano degli enum per impostare il testo del valore selezionato
		* @param item Elemento selezionato
		*/
		public enumDropDown_displayExpr(item: Seac.Models.DropDownBoxEnumElement): string {
			return item && (`${item.Key} - ${item.Label}`);
		}

		/**
		* Funzione richiamata dalle DropDownBox della pagina che visualizzano degli enum per impostare il testo (StringValue) del valore selezionato
		* @param item Elemento selezionato
		*/
		public enumDropDown_StringValue_displayExpr(item: Seac.Models.DropDownBoxEnumElement): string {
			return item && (`${item.StringValue} - ${item.Label}`);
		}

		/**
		* Funzione richiamata dalle DropDownBox della pagina che visualizzano degli enum per impostare il testo del valore selezionato
		* @param item Elemento selezionato
		*/
		public enumDropDown_displayExpr_withCharValue(item: Seac.Models.DropDownBoxEnumElement): string {
			return item && (`${item.CharValue} - ${item.Label}`);
		}

		/**
		* Metodo utilizzato per ridimensionare la larghezza della lista visualizzata dalla SelectBox
		* @param event Evento opened
		* @param width Larghezza della lista visualizzata dalla SelectBox
		*/
		public resizeSelectBoxContent(event: Seac.Commons.DxEvents.DxSelectBoxOpenedEvent, width: number, marginLeft: number = 0) {
			event.component.content().parent().css({'min-width': `${width}px`, 'margin-left': marginLeft});
		}

		/**
		* Metodo utilizzato per ridimensionare la larghezza della lista visualizzata dalla SelectBox
		* @param event Evento opened
		* @param width Larghezza della lista visualizzata dalla SelectBox
		*/
		public resizeHeightSelectBoxContent(event: Seac.Commons.DxEvents.DxSelectBoxOpenedEvent, height: number | 'auto') {
			event.component.content().css({'height': (height == `auto` ? height : `${height}px`)});
		}

		/**
		* Esporta i dati di tutte le pagine di una griglia DevExpress
		* @param gridInstance Istanza della griglia di cui esportare i dati
		* @param exportHiddenColumns Indica se esportare le colonne nascoste
		*/
		public exportGridToXlsx(gridInstance: DevExpress.ui.dxDataGrid, exportHiddenColumns: boolean): void {
			const workbook = new (<any>window).ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet(`${Seac.Resources.Common.xlsx_foglio} 1`);

			const columnNumber			: number		= gridInstance.columnCount();
			const hiddenColumnsIndexes	: Array<number>	= new Array<number>();

			if (exportHiddenColumns) {
				for (let indexOfColumn = 0; indexOfColumn < columnNumber; indexOfColumn++) {
					if (gridInstance.columnOption(indexOfColumn, Seac.Commons.Constants.DevExpress.dxVisible) == false) {
						gridInstance.columnOption(indexOfColumn, Seac.Commons.Constants.DevExpress.dxVisible, true);
						hiddenColumnsIndexes.push(indexOfColumn);
					}
				}
			}

			DevExpress.excelExporter.exportDataGrid({
				component			: gridInstance,
				worksheet			: worksheet,
				autoFilterEnabled	: false,
				customizeCell		: this.customizeExcelCell
			}).then(() => {
				workbook.xlsx.writeBuffer().then((buffer) => {
					saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Export.xlsx');
				});
				if (exportHiddenColumns) {
					for (let indexOfArrayOfHiddenColumns = 0; indexOfArrayOfHiddenColumns < hiddenColumnsIndexes.length; indexOfArrayOfHiddenColumns++) {
						gridInstance.columnOption(hiddenColumnsIndexes[indexOfArrayOfHiddenColumns], 'visible', false);
					}
				}
			});
		}
	}

	export let dxComponentsUtils = new DxComponentsUtils();

	/** Evento di click su una cella del calendario */
	export interface dxSchedulerCellClickEvent {
		component?		: DevExpress.ui.dxScheduler;
		element?		: DevExpress.core.dxElement;
		model?			: any;
		cellData?		: any;
		cellElement?	: DevExpress.core.dxElement;
		event?			: DevExpress.events.event;
		cancel?			: boolean;
	}
}
